var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-menu"},[(_vm.started)?_c('div',{staticClass:"playing-menu"},[_c('game-hits'),_c('game-timer')],1):_c('div',{staticClass:"start-menu"},[_c('button',{on:{"click":_vm.start}},[_vm._v("Start")])])])}
var staticRenderFns = []

export { render, staticRenderFns }